import React from 'react';

import {
    Glyphicon,
    SubHeading,
} from 'reaxl';

function SubSectionHeader({ heading, description, footer, glyph, children, ...rest }) {
    return (
        <div
            className="margin-bottom-4 text-size-300"
            {...rest}
        >
            <div className="margin-bottom-1">
                <SubHeading size={400}>
                    {!!glyph && (
                        <Glyphicon
                            className="text-success margin-right-1 text-bold text-size-500"
                            glyph={glyph}
                        />
                    )}
                    {heading}
                </SubHeading>
            </div>
            <p>
                {description}
            </p>
            {children}
            {footer && <p className="text-size-300">{footer}</p>}
        </div>
    );
}

export default React.memo(SubSectionHeader);
